/**
 * 세그먼트 (프로토타입: 입력창 하루/고민 32, 입회 양력/음력 36).
 * 선택된 칸은 --color-surface 바탕에 굵은 글자입니다.
 *
 * @param {{ value: string, label: string }[]} options
 */
const SIZE_CLASSES = {
    sm: { group: 'h-8 rounded-lg', item: 'h-7 px-3.5 text-[13px] rounded-md' },
    md: { group: 'h-9 rounded-[10px]', item: 'h-8 px-4 text-label rounded-lg' },
};

export function SegmentedControl({ options, value, onChange, ariaLabel, size = 'sm' }) {
    const sizeClasses = SIZE_CLASSES[size];
    return (
        <div
            role="group"
            aria-label={ariaLabel}
            className={`flex self-start bg-surface-sunken p-0.5 ${sizeClasses.group}`}
        >
            {options.map((option) => {
                const isSelected = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isSelected}
                        onClick={() => {
                            onChange(option.value);
                        }}
                        className={`${sizeClasses.item} ${
                            isSelected
                                ? 'bg-surface font-semibold text-text-primary'
                                : 'font-normal text-text-secondary'
                        }`}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
